import { useSelector } from "react-redux";
import TransferCard from "../TransferCard";

const getTransferedChats = ({ chatsData }) => chatsData.transferedChats;

function TransferedChats() {
  const transferedChats = useSelector(getTransferedChats);

  if (transferedChats.length > 0) {
    return (
      <>
        {transferedChats.map((chat, index) => (
          <TransferCard key={index} chat={chat} />
        ))}
      </>
    );
  }

  return null;
}

export default TransferedChats;
